import { toggleSidebar } from '../../redux/slices/sidebarslice';
import { AdminListReq } from '../../redux/slices/admin.slice';
import { addFilter } from '../../redux/slices/filter.slice';
import { AuthLogout } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoLanguage } from "react-icons/io5";
import Images from '../../assets/js/images';
import { Form } from 'react-bootstrap';
import { Cookies } from 'react-cookie';
import { Avatar } from '@mui/material';
import Select from "react-select";
import i18next from 'i18next';

const Header = () => {
  const cookies = new Cookies()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [language, setLanguage] = useState(false);
  const [usermenu, setUsermenu] = useState(false);
  const [selectedLang, setSelectedLang] = useState([])
  const [notification, setNotification] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const { admins } = useSelector(state => state.AdminSlice)
  const { filter } = useSelector(state => state.FilterSlice)
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: user } = useSelector(state => state.AuthSlice)
  const { data: sidebar } = useSelector(state => state.SidebarSlice)

  const languages = [
    {
      dir: 'ltr',
      code: 'fr',
      name: 'French',
      country_code: 'FR',
    },
    {
      dir: 'ltr',
      code: 'en',
      name: 'English',
      country_code: 'EN'
    },
  ]

  const ChangeLanguage = (value) => {
    i18next.changeLanguage(value)
    const currentLangCode = cookies.get('i18next') || 'en';
    const currentLanguage = languages.find(l => l.code === currentLangCode);
    document.body.dir = currentLanguage.dir;
  }

  // const getCountriesData = async () => {
  //   const response = await fetch("https://restcountries.com/v3.1/all");
  //   const data = await response.json();

  //   return data.map((country) => ({
  //     value: country.cca2,
  //     label: country.name.common,
  //     flagUrl: `https://flagcdn.com/w320/${country.cca2.toLowerCase()}.png`
  //   }));
  // };

  const getCountriesData = async () => {
    try {
      const response = await fetch("https://restcountries.com/v3.1/all?fields=cca2,name");
      if (!response.ok) {
        throw new Error("Failed to fetch countries");
      }

      const data = await response.json();

      return data
        .filter(country => country.cca2 && country.name?.common)
        .map(country => ({
          value: country.cca2,
          label: country.name.common,
          flagUrl: `https://flagcdn.com/w320/${country.cca2.toLowerCase()}.png`
        }));
    } catch (error) {
      console.error("Error fetching countries:", error);
      return [];
    }
  };

  const FlagOption = ({ innerProps, isDisabled, data }) => {
    if (isDisabled) return null;

    return (
      <div {...innerProps} className="country-option">
        <img
          src={data.flagUrl}
          alt={data.label}
          className="flag-icon"
          style={{ width: "24px", marginRight: "10px" }}
        />
        {data.label}
      </div>
    );
  };


  const handleLogout = (id) => {
    dispatch(AuthLogout({ id: id, navigate }));
    dispatch({ type: "LOGOUT", payload: "" });
  }

  useEffect(() => {
    const currentLangCode = cookies.get('i18next') || 'en';
    const currentLanguage = languages.find(l => l.code === currentLangCode);
    setSelectedLang([...selectedLang, currentLanguage])

    if (user?.role === 'superadmin' && user?.role === 'admin') {
      dispatch(AdminListReq({}))
    }
    getCountriesData().then((data) => {
      setCountryOptions(data);
      const argentina = data.find((country) => country.label === "Argentina");
      setSelectedOption(argentina);
    });
    setUsermenu(false);
  }, [navigate])

  useMemo(() => {
    return user;
  }, [user])

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const handleSearch = (e) => {
    e.preventDefault()
  }

  return (
    <header>
      <div className="topbar d-flex align-items-center">
        <nav className="navbar navbar-expand gap-3">
          <button type="button" className="btn px-0 m-0 menu-btn" onClick={() => dispatch(toggleSidebar(sidebar ? false : true))}><i className='bx bx-menu'></i>
            {/* <div className="mobile-toggle-menu"><i className='bx bx-menu'></i> */}
          </button>
          <div className="search-bar">
            <div className="position-relative search-bar-box border rounded">
              <Form onSubmit={handleSearch}>
                <Form.Control type="text" className="search-control" autoFocus placeholder={t('search')} value={filter || ''} onChange={(e) => { dispatch(addFilter(e.target.value !== "" ? e.target.value : '')) }} /> <span className="position-absolute top-50 search-show translate-middle-y"><i className='bx bx-search'></i></span>
              </Form>
            </div>
          </div>
          {(user?.role === 'superadmin' || user?.role === 'subadmin') &&
            <Select
              className='country-dropdown'
              style={{ width: '200px' }}
              value={selectedOption}
              onChange={handleChange}
              options={countryOptions}
              getOptionLabel={(option) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={option.flagUrl}
                    alt={option.label}
                    className="flag-icon"
                    style={{ width: "24px", marginRight: "10px" }}
                  />
                  {option.label}
                </div>
              )}
              components={{ Option: FlagOption }}
            />
          }
          <div className="top-menu ms-auto">
            <ul className="navbar-nav align-items-center gap-1">
              {user?.role === 'superadmin' &&
                <Link type="button" className="nav-link access_header_btn" onClick={() => setShow(true)}>{t('header_subadmin_btn')}</Link>
              }
              <li className="nav-item dropdown multilang-dropdown">
                <a className={`nav-link dropdown-toggle dropdown-toggle-nocaret position-relative ${language && 'show'}`} role="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={() => { setLanguage(!language) }}>
                  <IoLanguage />
                </a>
                <div className={`dropdown-menu dropdown-menu-end p-0 ${language && 'show'}`} style={{ top: '100%', right: 0, left: 'auto', height: '62px' }}>
                  <div className="header-notifications-list">
                    <a className={`dropdown-item ${cookies.get('i18next') === 'en' && 'active'}`} type="button" onClick={() => { ChangeLanguage('en'); setLanguage(!language) }}>
                      <p className="msg-name m-0">{t('english')}</p>
                    </a>
                    <a className={`dropdown-item ${cookies.get('i18next') === 'fr' && 'active'}`} type="button" onClick={() => { ChangeLanguage('fr'); setLanguage(!language) }}>
                      <p className="msg-name m-0">{t('french')}</p>
                    </a>
                  </div>
                </div>
              </li>
              <li className="nav-item dropdown dropdown-large">
                <a className={`nav-link dropdown-toggle dropdown-toggle-nocaret position-relative ${notification && 'show'}`} role="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={() => { setNotification(!notification) }}> <span className="alert-count">0</span>
                  <i className='bx bx-bell'></i>
                </a>
                <div className={`dropdown-menu dropdown-menu-end ${notification && 'show'}`} style={{ top: '100%', right: 0, left: 'auto' }}>
                  <a type="button" className='w-100'>
                    <div className="msg-header">
                      <p className="msg-header-title">{t('notification')}</p>
                      <p className="msg-header-clear ms-auto">{t('mark_all')}</p>
                    </div>
                  </a>
                  <div className="header-notifications-list">
                    <a className="dropdown-item" href="">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-primary text-primary"><i className="bx bx-group"></i>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Customers<span className="msg-time float-end">14 Sec
                            ago</span></h6>
                          <p className="msg-info">5 new user registered</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-danger text-danger"><i className="bx bx-message-detail"></i>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Comments <span className="msg-time float-end">4 hrs
                            ago</span></h6>
                          <p className="msg-info">New customer comments recived</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  {/* <a type='button'>
                    <div className="text-center msg-footer">View All Notifications</div>
                  </a> */}
                </div>
              </li>
            </ul>
          </div>
          <div className="user-box dropdown px-3">
            <a className={`d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret ${usermenu && 'show'}`} role="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => {
              setUsermenu(!usermenu)
            }}>
              {user?.image ?
                <img src={`${process.env.REACT_APP_FILE_URL}${user?.image ? user?.image : Images?.profile}`} alt={user?.role} className="user-img" /> :
                <Avatar
                  alt={user?.firstname ? user?.firstname : user?.email}
                  src={user?.image}
                  sx={{ width: 42, height: 42 }}
                />
              }
            </a>
            {/* dropdown-menu-end */}
            <ul className={`dropdown-menu p-0  ${usermenu && 'show'}`} style={{ top: '100%', right: 0 }}>
              <li><a className="dropdown-item border-bottom d-flex flex-column" type="button">
                <span className='font-16'>{user?.fullname}</span>
                <small style={{ fontSize: '10px' }}>{user?.email}</small>
              </a>
              </li>
              <li><Link className="dropdown-item border-bottom" to={`/${(user?.role === 'superadmin' || user?.role === 'subadmin') ? 'subadmin' : user?.role}/profile`}><i className="bx bx-user"></i><span>{t('profile')}</span></Link>
              </li>
              {/* <li><a className="dropdown-item" type="button"><i><BiCog /></i><span>{t('setting')}</span></a></li> */}
              {/* <li><Link className="dropdown-item" to={`/${user?.role === 'superadmin' ? 'subadmin' : user?.role}/dashboard`}><i className='bx bx-home-circle'></i><span>Dashboard</span></Link>
              </li> */}
              <li><a className="dropdown-item" type="button" onClick={() => { handleLogout(user?._id) }}><i className='bx bx-log-out-circle'></i><span>{t('logout')}</span></a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  )
}

export default Header;